import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import './Assets/styles/default/common/button.less';


import Store from 'redux/store';
import App from './App';
import reportWebVitals from './reportWebVitals';

import ProviderLanguage from './Services/Providers/ProviderLanguage';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import dayjs from 'dayjs';
import { Helmet } from 'react-helmet';

dayjs.extend(weekday);
dayjs.extend(localeData);

const root = ReactDOM.createRoot(document.getElementById('root'));

const designTokens = localStorage.getItem('designTokens');
const Favicon = (designTokens && JSON.parse(designTokens)['favicon']) || (designTokens && JSON.parse(designTokens)['favicon'])  || 'https://vertice-ds.s3.amazonaws.com/Assets/Images/Favicon/default/favicon.ico';

root.render(
    <Provider store={Store}>
        <ProviderLanguage>
            <Helmet>
              <link rel="icon" href={Favicon} />
            </Helmet>
            <App />
        </ProviderLanguage>
    </Provider>
    );
const title = process.env.REACT_APP_TITLE;
document.title = title;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
